/**
 * @module Transform
 * This module exports constants that are used to reference transforms in
 * a consistent manner throughout the project.
 */
/* eslint one-var: 0 */
 export const IDENTITY = 'identity';
 export const GROUP = 'group';
 export const STACK = 'stack';
 export const FRACTURE = 'fracture';
